<template>
    <div class="menu">
        <dl>
          <dd v-for="(item,index) in this.lang[this.local].menu" @click="jumpTo(`#part-${index + 1}`)" :class=" activeMenu == (index) ? 'cur':''" >{{item}}</dd>
        </dl>
    </div>
</template>
<script>
    import {mapState} from "vuex"
    export default {
        data(){
          return{
            activeMenu:0,
            allOffset:[],
          }
        },
        computed:
          mapState(['lang','local'])
        ,
        mounted(){
          this.$nextTick(function () {
          this.lang[this.local].menu.map((d,i)=>{
            this.allOffset.push(document.querySelector(`#part-${i+1}`).offsetTop)
          })
            window.addEventListener('scroll', this.onScroll)
          })
        },
        methods:{
          change(){
          },
          onScroll() {
            let scrolled = document.documentElement.scrollTop || document.body.scrollTop
            let count = 0
            let len = this.allOffset.length
            this.allOffset.map((d,i)=>{
              if (scrolled > d ){
                count++
                (i == (len -1)) && (this.activeMenu = count)
              }else{
                this.activeMenu = count
              }
            })            
          },
          jumpTo(id){
            let len = document.querySelector(id).offsetTop
            const sTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.scrollTop(window, sTop, len, this.duration)
            this.$parent && this.$parent.handleClose()
          },

          scrollTop(el, from = 0, to, duration = 1000, endCallback) {
            if (!window.requestAnimationFrame) {
                window.requestAnimationFrame = (
                    window.webkitRequestAnimationFrame ||
                    window.mozRequestAnimationFrame ||
                    window.msRequestAnimationFrame ||
                    function (callback) {
                        return window.setTimeout(callback, 1000/60);
                    }
                );
            }
            const difference = Math.abs(from - to);
            const step = Math.ceil(difference / duration * 50);
            function scroll(start, end, step) {
                if (start === end) {
                    endCallback && endCallback();
                    return;
                }

                let d = (start + step > end) ? end : start + step;
                if (start > end) {
                    d = (start - step < end) ? end : start - step;
                }

                if (el === window) {
                    window.scrollTo(d, d);
                } else {
                    el.scrollTop = d;
                }
                window.requestAnimationFrame(() => scroll(d, end, step));
            }
            scroll(from, to, step);
          }
        }
    }
</script>

<style lang="less" scoped>
@width:190px;
.menu{
  text-align:center;
  width: @width;
  dl{    
      color:#FFB5B4;
      text-align: left;
    dt{
      cursor: pointer;
      i{
        font-size: 22px;
      }
    }
    dd{    
      display:block;
      background: #421717;
      opacity:.9;
      font-size:15px;
      padding:15px;
      cursor:pointer;
      &.cur{background: #562927;border-bottom:1px solid red}
      &:hover{
        background: #562927;
      }
      &:nth-child(1){
        position: relative;
        &:before{
          border:2px solid #000;
          position:absolute;
          top:3px;
          left:50%;
        }
      }
    }
  }
  
}
</style>


